import { listen, add, remove } from '@fluorescent/dom';

import { on } from '@/glow/events';

export default function HomeSectionModifiers(node) {
  // We only want to enable the transparent header in select
  // situations on the homepage:
  //   - First section is a slideshow
  const handleTransparentCheck = firstSection => {
    if (
      firstSection.classList.contains('slideshow') ||
      firstSection.classList.contains('video-hero') ||
      firstSection.classList.contains('full-width-image')
    ) {
      add(firstSection, 'transparent-section');
    } else {
      remove(firstSection, 'transparent-section');
    }
  };

  const handleHeaderBorder = firstSection => {
    const header = document.getElementById('header');
    if (
      firstSection.classList.contains('slideshow') ||
      firstSection.classList.contains('video-hero') ||
      firstSection.classList.contains('full-width-image')
    ) {
      add(header, 'header--no-border');
    } else {
      remove(header, 'header--no-border');
    }
  };

  const handleFirstSection = () => {
    const firstSection = node.firstElementChild.firstElementChild;
    handleTransparentCheck(firstSection);
    handleHeaderBorder(firstSection);
  };

  handleFirstSection();

  on('headerChange', handleFirstSection);
  on('transparentSectionUpdate', handleFirstSection);

  listen(window, 'shopify:section:reorder', handleFirstSection);
  listen(window, 'shopify:block:select', handleFirstSection);
}
